export enum Role {
  ADMIN = 'admin',
  CONFIGURATOR = 'configurator',
  EMPLOYEE = 'employee',
  MANAGER = 'manager',
  UBER_ADMIN = 'uber_admin',
  CATI_AGENT = 'cati_agent',
}
